import { lazy } from 'react';

/**
 * Lazy import avec retry automatique sur erreur de chunk.
 * Après un déploiement, le navigateur peut avoir d'anciens chunks en cache
 * qui référencent des sous-chunks qui n'existent plus. On recharge la page une seule fois.
 */
export default function lazyWithRetry(factory: () => Promise<{ default: React.ComponentType<any> }>) {
    return lazy(() =>
        factory().catch(() => {
            const key = 'chunk_reload_' + window.location.pathname;
            if (!sessionStorage.getItem(key)) {
                sessionStorage.setItem(key, '1');
                window.location.reload();
                // La page va se recharger — on retourne une Promise qui ne résout jamais
                // pour que Suspense affiche le loader au lieu d'un flash d'erreur
                return new Promise<never>(() => {});
            }
            return factory();
        })
    );
}
